
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"isolation":"isolate"}},[_c('path',{attrs:{"d":"M74.84.1H27.43a7.94 7.94 0 00-7.81 9.33l24 133.94a7.94 7.94 0 007.81 6.53h46.81a7.94 7.94 0 007.81-6.53l24-133.94A7.94 7.94 0 00122.24.1z","fill":"#e8eae9"}}),_c('path',{attrs:{"d":"M74.84 36.51H36.79a1.93 1.93 0 00-1.9 2.26l17.22 98.79a1.94 1.94 0 001.91 1.6h41.63a1.94 1.94 0 001.91-1.6l17.22-98.79a1.93 1.93 0 00-1.9-2.26z","fill":"#3cc7f4"}}),_c('path',{staticStyle:{"mix-blend-mode":"darken"},attrs:{"d":"M122.57.1h-18.16l-4 50.34c-.31 4-.48 7.9-.63 11.86a136.48 136.48 0 01-12.88 53.18L68.15 149.9h30.42a7.94 7.94 0 007.81-6.53l24-133.94A7.94 7.94 0 00122.57.1z","fill":"#d1d3d2","opacity":".8"}}),_c('path',{staticStyle:{"mix-blend-mode":"lighten"},attrs:{"d":"M38.59 7.23h9.64a3 3 0 013 2.87L55 78.7a3 3 0 01-6 .74l-13.39-68.6a3 3 0 012.98-3.61z","fill":"#fff","opacity":".4"}}),_c('circle',{attrs:{"cx":"74.85","cy":"91.92","r":"12.37","fill":"#fff"}}),_c('path',{attrs:{"fill":"#bcbec0","d":"M82.798 82.368l1.605 1.605-17.487 17.487-1.605-1.605z"}}),_c('circle',{attrs:{"cx":"84.52","cy":"59.24","r":"3","fill":"#fff"}}),_c('circle',{attrs:{"cx":"65.52","cy":"67.46","r":"1.02","fill":"#fff"}}),_c('circle',{attrs:{"cx":"77.04","cy":"49.57","r":"2.12","fill":"#fff"}}),_c('circle',{attrs:{"cx":"74.68","cy":"72.21","r":"2.12","fill":"#fff"}}),_c('circle',{attrs:{"cx":"69.59","cy":"109.17","r":"1.81","fill":"#fff"}})])])
          )
        }
      }
    